import { createAsyncThunk } from "@reduxjs/toolkit";
import { CONFIGURATIONS } from "../../config/envConfig";

let API_BASE_URL = CONFIGURATIONS.REACT_APP_CLODUFLARE_URL;

export const uploadToCloudflare = createAsyncThunk(
  "cloudflare/uploadFile",
  async ({ file, type = "images" }, thunkAPI) => {
    
    let UPLOAD_URL = `${API_BASE_URL}/${type}/`;
    if (type === "tracks") {
      UPLOAD_URL = `${API_BASE_URL}/${type}/play/`;
    }
    const API_KEY = CONFIGURATIONS.UPLOAD_API_KEY;

    if (!file || !(file instanceof File)) {
      return thunkAPI.rejectWithValue("Invalid file provided");
    }

    const formData = new FormData();
    formData.append("file", file);

    const response = await fetch(UPLOAD_URL, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${API_KEY}`,
      },
      body: formData,
    });
    const data = await response.json();

    console.log("dahhdd", response)

    if (!response.ok) {
      return thunkAPI.rejectWithValue(data.message || "Upload failed");
    }
    return data;
  }
);

export const fetchMediaMeta = createAsyncThunk(
  "cloudflare/fetchFileMeta",
  async ({ key, type = "images" }, thunkAPI) => {
    const API_KEY = CONFIGURATIONS.UPLOAD_API_KEY;

    try {
      if (type === "tracks") {
        key = `play/${key}`;
      }
      const res = await fetch(`${API_BASE_URL}/${type}/${key}`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${API_KEY}`,
        },
      });

      if (!res.ok) {
        const errMessage = await res.text();
        throw new Error(errMessage || "File not found or unauthorized");
      }

      return { res };
    } catch (err) {
      return thunkAPI.rejectWithValue(err.message);
    }
  }
);

export const deleteFromCloudflare = createAsyncThunk(
    "cloudflare/deleteFile",
    async ({ key, type = "images" }, thunkAPI) => {
        const API_KEY = CONFIGURATIONS.UPLOAD_API_KEY;

        try {
            if (type === "tracks") {
                key = `play/${key}`;
            }
            const res = await fetch(`${API_BASE_URL}/${type}/${key}`, {
                method: "DELETE",
                headers: {
                    Authorization: `Bearer ${API_KEY}`,
                },
            });

            if (!res.ok) {
                const errMessage = await res.text();
                throw new Error(errMessage || "Delete failed");
            }

            return { key };
        } catch (err) {
            return thunkAPI.rejectWithValue(err.message);
        }
    }
);

